const apiUrl = "https://apiindianbookhouse.abilioit.com/api/v1"

export default apiUrl;